export const MONTHS = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
]

export function formatDate(date: Date, fullMonth = false): string {
  const year = date.getFullYear()

  if (fullMonth) {
    const month = MONTHS[date.getMonth()]
    const day = '' + date.getDate()

    return `${day}. ${month} ${year}`
  }

  let month = '' + (date.getMonth() + 1)
  let day = '' + date.getDate()
  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [day, month, year].join('.')
}

export function formatTime(date: Date): string {
  const hours = date.getHours().toString()
  let minutes = date.getMinutes().toString()

  if (minutes.length < 2) {
    minutes = '0' + minutes
  }

  return [hours, minutes].join('.')
}
